
























































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { GET_ITEMS } from '@/modules/home/store/getters'
import { Item } from 'vue-modules'
import HomeForm from '@/modules/home/components/HomeForm.vue'
const CardItem = () => import('@/modules/home/components/CardItem.vue')
import { KinesisContainer, KinesisElement } from 'vue-kinesis'

const home = namespace('home')

@Component({
  components: { CardItem, HomeForm, KinesisContainer, KinesisElement }
})
export default class Home extends Vue {
  @home.Getter(GET_ITEMS) items!: [Item]
}
